import { useMemo } from 'react';
import { useGlobalTheme } from '../useGlobalTheme';
import { useIsDarkMode } from '../useIsDarkMode';
import { createV8Theme } from './createV8Theme';
// Exposes Fluent theme V8/V7 version that is still used in some components coming from 1JS repository
export function useLegacyFluentTheme() {
    var isDarkMode = useIsDarkMode();
    var theme = useGlobalTheme();
    var v8Theme = useMemo(function () {
        var newV8Theme = createV8Theme({
            10: theme.colorBrandForegroundOnLightSelected,
            20: theme.colorBrandForegroundOnLightSelected,
            30: theme.colorBrandForegroundOnLightSelected,
            40: theme.colorBrandForegroundOnLightSelected,
            50: theme.colorBrandForegroundOnLightSelected,
            60: theme.colorBrandForegroundOnLightPressed,
            70: theme.colorBrandForegroundOnLightHover,
            80: theme.colorBrandForeground1,
            90: theme.colorBrandForeground2,
            100: theme.colorBrandForeground2,
            110: theme.colorBrandForegroundInverted,
            120: theme.colorBrandForegroundInverted,
            130: theme.colorBrandForegroundInverted,
            140: theme.colorBrandForegroundInverted,
            150: theme.colorBrandBackgroundInvertedPressed,
            160: theme.colorBrandBackground2,
        }, theme, isDarkMode);
        return newV8Theme;
    }, [isDarkMode, theme]);
    return v8Theme;
}
//# sourceMappingURL=useLegacyFluentTheme.js.map